import { useState } from "react";
import { motion } from "framer-motion";
import { Copy, Check, Landmark } from "lucide-react";
import { SITE } from "@/data/site";
import { toast } from "sonner";

export const PaymentInfo = () => {
  const [copied, setCopied] = useState(false);

  const copyIban = async () => {
    try {
      await navigator.clipboard.writeText(SITE.account.iban.replace(/\s/g, ""));
      setCopied(true);
      toast.success("IBAN panoya kopyalandı.");
      setTimeout(() => setCopied(false), 2200);
    } catch {
      toast.error("Kopyalanamadı.");
    }
  };

  return (
    <section id="odeme" className="py-24 lg:py-32 beige-soft">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-xl mx-auto mb-12">
          <span className="eyebrow">Ödeme</span>
          <h2 className="font-display text-4xl lg:text-5xl mt-3 text-[hsl(var(--nl-anthracite))]">
            Ödeme ve <em className="not-italic font-serif italic gold-text">Hesap Bilgileri</em>
          </h2>
          <div className="gold-line mt-5 mx-auto" />
          <p className="mt-6 text-sm text-[hsl(var(--muted-foreground))]">
            Havale / EFT ile ödemelerinizi aşağıdaki hesabımıza gerçekleştirebilirsiniz. Ödeme sonrası
            dekontunuzu WhatsApp üzerinden bize iletmeniz yeterli.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="bg-white border border-[hsl(var(--nl-line))] p-8 lg:p-12 relative overflow-hidden"
          data-testid="payment-card"
        >
          <div className="absolute -right-10 -top-10 w-44 h-44 rounded-full bg-[hsl(var(--nl-champagne)/0.1)]" />
          <Landmark className="gold-text" size={28} strokeWidth={1.5} />
          <div className="mt-6 grid sm:grid-cols-2 gap-x-10 gap-y-7">
            <div>
              <p className="eyebrow">Banka</p>
              <p className="font-serif text-2xl text-[hsl(var(--nl-anthracite))] mt-2" data-testid="bank-name">
                {SITE.account.bankName}
              </p>
            </div>
            <div>
              <p className="eyebrow">Hesap Sahibi</p>
              <p className="font-serif text-2xl text-[hsl(var(--nl-anthracite))] mt-2" data-testid="account-holder">
                {SITE.account.accountHolder}
              </p>
            </div>
            <div className="sm:col-span-2">
              <p className="eyebrow">IBAN</p>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mt-2 pt-3 border-t border-[hsl(var(--nl-line))]">
                <p className="font-mono tracking-wider text-base lg:text-lg text-[hsl(var(--nl-anthracite))]" data-testid="iban-value">
                  {SITE.account.iban}
                </p>
                <button
                  data-testid="copy-iban"
                  onClick={copyIban}
                  className="btn-ghost-gold !text-[10px] shrink-0"
                >
                  {copied ? <><Check size={12} /> Kopyalandı</> : <><Copy size={12} /> IBAN&apos;ı Kopyala</>}
                </button>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-dashed border-[hsl(var(--nl-line))] text-xs text-[hsl(var(--muted-foreground))] leading-relaxed">
            ℹ️ Ödemeyi gerçekleştirdikten sonra, dekontunuzu ve sipariş detayınızı WhatsApp hattımıza
            iletmeniz halinde siparişiniz aynı gün hazırlanmaya başlar.
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PaymentInfo;
